import * as v from 'valibot';
import { Metadata } from './metadata';
export var VictimSchema;
(function (VictimSchema) {
    VictimSchema.Victim = v.object({
        id: v.number(),
        fullname: v.string(),
        info: v.string(),
        version: v.number()
    });
    VictimSchema.ListResponse = v.object({
        victims: v.array(VictimSchema.Victim),
        metadata: v.partial(Metadata)
    });
    VictimSchema.Filters = v.object({
        fullname: v.nullish(v.string()),
        info: v.nullish(v.string()),
        page: v.optional(v.number())
    });
})(VictimSchema || (VictimSchema = {}));
